import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import * as styles from "./InvoiceEditDetailsStyles";

interface EditInvoiceModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (data: {
    exciseID: string;
    customerExecLeafNo: string;
    transporter: string;
    transporterPermitNo: string;
    vehicleNumber: string;
    serviceID?: string | null;
  }) => void;
  initialFormData?: {
    exciseID: string;
    customerExecLeafNo: string;
    transporter: string;
    transporterPermitNo: string;
    vehicleNumber: string;
    serviceID?: string | null;
  };
}

const EditInvoiceModal: React.FC<EditInvoiceModalProps> = ({
  open,
  onClose,
  onConfirm,
  initialFormData = {
    exciseID: "",
    customerExecLeafNo: "",
    transporter: "",
    transporterPermitNo: "",
    vehicleNumber: "",
    serviceID: null,
  },
}) => {
  useEffect(() => {
    setFormData(initialFormData);
  }, [initialFormData]);

  const [formData, setFormData] = useState(initialFormData);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleConfirm = () => {
    onConfirm(formData);
    setFormData(initialFormData);
    onClose();
  };
  const handleClose = () => {
    setFormData(initialFormData);
    onClose();
  };

  const fields = [
    {
      name: "serviceID",
      label: "Service Bill Invoice Number",
      placeholder: "Service Bill Invoice Number",
      value: formData.serviceID,
    },
    {
      name: "transporterPermitNo",
      label: "Transporter Permit No.",
      placeholder: "Transporter Permit No.",
      value: formData.transporterPermitNo,
    },

    {
      name: "customerExecLeafNo",
      label: "Customer Exec. Leaf No.",
      placeholder: "Customer Exec. Leaf No.",
      value: formData.customerExecLeafNo,
    },
    {
      name: "transporter",
      label: "Transporter",
      placeholder: "Transporter",
      value: formData.transporter,
    },

    {
      name: "vehicleNumber",
      label: "Vehicle Number",
      placeholder: "Vehicle Number",
      value: formData.vehicleNumber,
    },
    {
      name: "exciseID",
      label: "Excise Invoice Number",
      placeholder: "Excise Invoice Number",
      value: formData.exciseID,
    },
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="edit-invoice-modal"
      aria-describedby="edit-invoice-description"
      disableScrollLock={false}
    >
      <Box sx={styles.modalContainer}>
        <Typography
          id="edit-invoice-modal"
          variant="h6"
          component="h1"
          sx={styles.titleStyle}
        >
          Edit Invoice
        </Typography>
        <Box sx={{ overflowY: "auto", flexGrow: 1, pr: 1 }}>
          <Stack spacing={3}>
            {fields.map((field) => (
              <Box key={field.name}>
                <Typography variant="body2" sx={styles.fieldLabelStyle}>
                  {field.label}
                </Typography>
                <TextField
                  name={field.name}
                  value={field.value}
                  onChange={handleChange}
                  placeholder={field.placeholder}
                  fullWidth
                  variant="outlined"
                  sx={styles.textFieldStyle}
                />
              </Box>
            ))}
          </Stack>
        </Box>

        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
          sx={styles.stackSpacingStyle}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            sx={styles.buttonConfirmStyle}
          >
            Confirm
          </Button>
          <Button sx={styles.buttonCancelStyle} onClick={handleClose}>
            Cancel
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default EditInvoiceModal;
